import { AuthenticationService } from './../../servicios/authentication.service';
import { Component, OnInit, EventEmitter,  ViewChild } from '@angular/core';
import { Aguas, PersonaClientes, BuscaTramite, EstadoCuentaInformacionInput, SolicitudDetalles, Medidores } from '../../entidades/entidades'; // prettier-ignore
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { async } from 'rxjs/internal/scheduler/async';
import { BuscaPersonaClientesService } from 'app/servicios/busca-persona-clientes.service';
import { SolicitudDetallesGridComponent } from '../solicitud-detalles-grid/solicitud-detalles-grid.component';
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { SolicitudDetallesService } from "../../servicios/solicitud-detalles.service";
import { ActivatedRoute, Router } from '@angular/router';
import { MedidoresService } from "../../servicios/medidores.service";
import {RegistroBitacoraInput} from '../../entidades/entidades'
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
@Component({
  selector: "app-alta-medidores",
  templateUrl: "./alta-medidores.component.html",
  styleUrls: ["./alta-medidores.component.css"],
})
export class AltaMedidoresComponent implements OnInit {
  @ViewChild(SolicitudDetallesGridComponent, { static: false })
  childSolicitudDetallesGrid;

  public estadoCuentaInformacionInput$ = new EventEmitter<
    EstadoCuentaInformacionInput
  >();
  public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;
  muestraMensaje = new MuestraMensaje();
  usuario: any;
  public medidores$ = new EventEmitter<Medidores>();
  public medidoresLimpio: Medidores;
  datosPClientesForm: FormGroup;
  datosClientes = new PersonaClientes();
  public registroBitacora = new RegistroBitacoraInput();

  public IdSolicitud: string;
  public IdAgua: number;
  datos: any;

  ///////PROGRESS BAR///////////////////
  public progressBar = false;
  mensajeForm: FormGroup;
  showBar() {
    this.progressBar = true;
  }
  ////////////////////////////////////////////////

  // @ViewChild(EstadoCuentaInformacionComponent, { static: false }) childEstadoCuentaInformacion;

  constructor(
    private buscaPersonaClientesService: BuscaPersonaClientesService,
    private activatedRoute: ActivatedRoute,
    private solicitudDetallesService: SolicitudDetallesService,
    private router: Router,
    private medidoresService: MedidoresService,
    private formBuilder: FormBuilder,
    private authenticationService:AuthenticationService,
    private registroBitacoraService: RegistroBitacoraService

  ) {
    this.mensajeForm = new FormGroup({
      mensaje_: new FormControl(),
    });
  }

  async ngOnInit() {
    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue;

    this.mensajeForm = this.formBuilder.group({
      mensaje_: [undefined],
    });
    try {
      this.datos = history.state.example;
      if (this.datos) {
        this.IdSolicitud = this.datos.idSolicitudDetalle;
        this.IdAgua = this.datos.idAgua;
        await this.ObtieneInfo();
      } else {
        this.router.navigateByUrl("/");
      }
    } catch {
      this.muestraMensaje.notification(
        "No existe una solicitud Previa",
        "top",
        "center"
      );
    }
  }

  async childMedidores(medidor:Medidores)
  {
    try
    {
      await this.estadoCuentaInformacionInput$.emit(null);
      let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
      estadoCuentaInformacionInput.idAgua = medidor.idAgua;

      await this.estadoCuentaInformacionInput$.emit(
        estadoCuentaInformacionInput
      );
    }catch(e){
      throw e;
    }
  }

  async ObtieneInfo() {
    try {
      this.progressBar = true;

      await this.estadoCuentaInformacionInput$.emit(null);
      let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
      estadoCuentaInformacionInput.idAgua = this.IdAgua;

      await this.estadoCuentaInformacionInput$.emit(
        estadoCuentaInformacionInput
      );


      //Carga medidores
      const medidoresInput = new Medidores();
      medidoresInput.idAgua = this.IdAgua;
      await this.medidores$.emit(medidoresInput);
      
     

    }catch(e){
      throw e;
    }finally {
      this.progressBar = false;

    }


  }
}

  